export default __webpack_public_path__ + "static/media/icon-forget-phone.6eadfc61.webp";